import * as React from 'react';
import useSettings from 'src/hooks/useSettings';

const LogoSiptel = (props) => {
  const { themeMode } = useSettings();
  if (themeMode === 'light') {
    return (
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 369.86 182.36"
        {...props}
      >
        <defs>
          <linearGradient
            id="Degradado_sin_nombre_9"
            x1={150.42}
            y1={-732.06}
            x2={258.29}
            y2={-732.06}
            gradientTransform="rotate(180 204.79 -287.58)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.26} stopColor="#fff" />
            <stop offset={0.34} stopColor="#fff" stopOpacity={0.82} />
            <stop offset={0.48} stopColor="#fff" stopOpacity={0.53} />
            <stop offset={0.61} stopColor="#fff" stopOpacity={0.3} />
            <stop offset={0.72} stopColor="#fff" stopOpacity={0.14} />
            <stop offset={0.8} stopColor="#fff" stopOpacity={0.04} />
            <stop offset={0.85} stopColor="#fff" stopOpacity={0} />
          </linearGradient>
          <linearGradient
            id="Degradado_sin_nombre_7"
            x1={139.06}
            y1={-825.21}
            x2={165.79}
            y2={-825.21}
            gradientTransform="rotate(180 145.315 -380.725)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.26} stopColor="#fff" />
            <stop offset={0.28} stopColor="#fff" stopOpacity={0.91} />
            <stop offset={0.36} stopColor="#fff" stopOpacity={0.67} />
            <stop offset={0.43} stopColor="#fff" stopOpacity={0.47} />
            <stop offset={0.51} stopColor="#fff" stopOpacity={0.3} />
            <stop offset={0.58} stopColor="#fff" stopOpacity={0.17} />
            <stop offset={0.64} stopColor="#fff" stopOpacity={0.08} />
            <stop offset={0.71} stopColor="#fff" stopOpacity={0.02} />
            <stop offset={0.76} stopColor="#fff" stopOpacity={0} />
          </linearGradient>
          <linearGradient
            id="Sky_1"
            x1={154.59}
            y1={151.96}
            x2={253.44}
            y2={151.96}
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#7bb9e7" />
            <stop offset={0.08} stopColor="#72b4e4" />
            <stop offset={0.22} stopColor="#58a7db" />
            <stop offset={0.4} stopColor="#2f91ce" />
            <stop offset={0.57} stopColor="#0078be" />
            <stop offset={1} stopColor="#154f9e" />
          </linearGradient>
          <linearGradient
            id="Sky_1-2"
            x1={154.59}
            y1={157.15}
            x2={253.44}
            y2={157.15}
            xlinkHref="#Sky_1"
          />
          <linearGradient
            id="Sky_1-3"
            x1={154.59}
            y1={162.09}
            x2={253.44}
            y2={162.09}
            xlinkHref="#Sky_1"
          />
          <mask
            id="mask"
            x={151.29}
            y={146.79}
            width={107.87}
            height={20.21}
            maskUnits="userSpaceOnUse"
          >
            <path
              style={{
                fill: 'url(#Degradado_sin_nombre_9)',
              }}
              d="M151.29 146.79h107.87V167H151.29z"
            />
          </mask>
          <mask
            id="mask-2"
            x={124.84}
            y={53.65}
            width={26.73}
            height={20.21}
            maskUnits="userSpaceOnUse"
          >
            <path
              style={{
                fill: 'url(#Degradado_sin_nombre_7)',
              }}
              d="M124.84 53.65h26.73v20.21h-26.73z"
            />
          </mask>
          <style>
            {
              '.cls-3{fill:#1d71b8;stroke:#1d71b8;stroke-miterlimit:10;strokeWidth:1.09px}.cls-8{fill:#24366b}'
            }
          </style>
        </defs>
        <path
          className="cls-3"
          d="M269.92 160.55a7.82 7.82 0 0 1-2.33 2.47 5.49 5.49 0 0 1-3 .86 4.79 4.79 0 0 1-3.74-1.63 6.86 6.86 0 0 1-1.47-4.74 11.76 11.76 0 0 1 1-4.77 7.49 7.49 0 0 1 2.65-3.39 6.21 6.21 0 0 1 3.36-1 4.79 4.79 0 0 1 3.2 1.12 5.07 5.07 0 0 1 1.7 3.06l-1.37.34a4.17 4.17 0 0 0-1.25-2.49 3.46 3.46 0 0 0-2.35-.85 4.6 4.6 0 0 0-4.12 2.69 10.64 10.64 0 0 0-1.19 5.27 6 6 0 0 0 1.06 4 3.28 3.28 0 0 0 2.63 1.25c1.57 0 2.92-.87 4.05-2.63ZM278 148.59h1.49l-1.27 6.68H286l1.27-6.68h1.47l-2.84 15h-1.49l1.35-7.09H278l-1.38 7.09h-1.5ZM295.18 148.59h1.47l-2.86 15h-1.47ZM303.15 148.59h1.46l-2.61 13.8h7.16l-.22 1.19h-8.64ZM316.14 148.59h8.53l-.23 1.19h-7.06l-1 5.33h5.71l-.23 1.2h-5.68l-1.18 6.08h7.56l-.23 1.19h-9Z"
        />
        <g
          style={{
            mask: 'url(#mask)',
          }}
        >
          <path
            style={{
              fill: 'url(#Sky_1)',
            }}
            d="M154.59 150.73h98.86v2.47h-98.86z"
          />
          <path
            style={{
              fill: 'url(#Sky_1-2)',
            }}
            d="M154.59 155.92h98.86v2.47h-98.86z"
          />
          <path
            style={{
              fill: 'url(#Sky_1-3)',
            }}
            d="M154.59 160.86h98.86v2.47h-98.86z"
          />
        </g>
        <path
          className="cls-8"
          d="M144.4 73.89a.58.58 0 0 0-.46-.22h-17.42a.61.61 0 0 0-.59.47l-4.42 21.16a37.39 37.39 0 0 1 1.06 9 38.15 38.15 0 0 1-7.88 23.62l-2.23 10.66a.61.61 0 0 0 .12.5.62.62 0 0 0 .47.22h17.41a.6.6 0 0 0 .59-.48l13.47-64.44a.57.57 0 0 0-.12-.49Z"
        />
        <g
          style={{
            mask: 'url(#mask-2)',
          }}
        >
          <path
            d="M127.32 70.87a.58.58 0 0 1-.44-.19.45.45 0 0 1-.12-.42l2.8-11.64a.57.57 0 0 1 .57-.41l17.23-.05a.6.6 0 0 1 .44.19.49.49 0 0 1 .12.43l-2.81 11.64a.57.57 0 0 1-.56.41Z"
            style={{
              fill: '#1d71b8',
            }}
          />
        </g>
        <path
          className="cls-8"
          d="M71.11 143.17c-10.3 0-19.36-1.76-26.93-5.23s-13.08-8.44-16.24-14.69a44.48 44.48 0 0 1-4.38-21.48.73.73 0 0 1 .7-.72l23.36-1.22a.76.76 0 0 1 .5.19.73.73 0 0 1 .24.52c.32 7.22 1.54 12.12 3.64 14.58 3.42 4 9.9 6.08 19.27 6.08 7.81 0 13.51-1.39 16.94-4.14s5.08-6 5.08-9.83a10.44 10.44 0 0 0-4.12-8.37c-2-1.73-7.64-4.62-16.77-8.58s-16.07-7.4-20.34-10.09A29.55 29.55 0 0 1 38 54.08a33.18 33.18 0 0 1 11.13-25.5c7.38-6.71 18.15-10.11 32-10.11 14.09 0 25.18 3.37 33 10s12.14 15.65 12.87 26.7a.78.78 0 0 1-.19.54.74.74 0 0 1-.52.25l-23.52 1a.74.74 0 0 1-.74-.66c-.57-5.47-2.56-9.71-5.92-12.6S87.69 39.38 81 39.38s-11.29 1.14-14 3.4a10.42 10.42 0 0 0-4.08 8.45 9.76 9.76 0 0 0 3.72 7.89c2.59 2.22 8.46 5.33 17.46 9.23 13.93 6 22.56 10.76 26.39 14.54 5.7 5.54 8.59 12.74 8.59 21.42 0 10.68-4.28 19.93-12.72 27.49s-20.29 11.37-35.25 11.37ZM133.05 163.89a.62.62 0 0 1-.47-.22.66.66 0 0 1-.12-.51l18.57-89a.6.6 0 0 1 .59-.47h16.5a.59.59 0 0 1 .47.22.61.61 0 0 1 .12.5l-1.05 5a37.38 37.38 0 0 1 8.73-5.28 26.58 26.58 0 0 1 10.12-1.93c6.9 0 12.54 2.42 16.74 7.18s6.31 11.88 6.31 21.21c0 11.71-3.62 21.75-10.77 29.83-6.16 6.94-13.56 10.46-22 10.46-8.21 0-14.61-3.18-19.06-9.46l-6.69 32a.6.6 0 0 1-.58.48Zm46.73-78.1a13 13 0 0 0-8.68 3.4c-2.64 2.29-4.71 5.71-6.17 10.17a39.24 39.24 0 0 0-2.21 11.86c0 4.84 1.18 8.64 3.52 11.29a10.53 10.53 0 0 0 8.19 3.95 12.86 12.86 0 0 0 7.95-3c2.57-2 4.74-5.41 6.44-10.11a39 39 0 0 0 2.61-13.23c0-4.64-1.11-8.23-3.3-10.67a10.77 10.77 0 0 0-8.35-3.66ZM229.88 140.83c-6.26 0-10.9-1.24-13.79-3.69s-4.41-5.95-4.41-10.32c0-2 .74-6.57 2.27-13.84l5.24-25.19h-7.69a.62.62 0 0 1-.47-.22.6.6 0 0 1-.12-.5l2.67-12.92a.6.6 0 0 1 .59-.48h8l2-9.84a.56.56 0 0 1 .28-.39l20-12a.68.68 0 0 1 .31-.08.58.58 0 0 1 .35.11.61.61 0 0 1 .24.61l-4.52 21.61h9.88a.58.58 0 0 1 .46.22.6.6 0 0 1 .13.5l-2.67 12.92a.61.61 0 0 1-.59.48h-10.2l-5.54 26.53a77.1 77.1 0 0 0-1.5 8.25 3.34 3.34 0 0 0 1.07 2.67c.73.65 2.15 1 4.21 1 .75 0 2.67-.14 5.71-.42h.06a.65.65 0 0 1 .45.2.63.63 0 0 1 .13.53l-2.73 12.92a.6.6 0 0 1-.46.47 47.36 47.36 0 0 1-9.36.87ZM276.12 140.83c-8.78 0-16-2.83-21.54-8.4s-8.31-13-8.31-22.18a40.34 40.34 0 0 1 7.46-23.89c6.76-9.43 16.54-14.21 29.07-14.21 8 0 14.5 2.52 19.24 7.5s7.15 12 7.15 20.89A49.79 49.79 0 0 1 308 112a.61.61 0 0 1-.59.46h-43.16v1a14.13 14.13 0 0 0 3.51 10 11.21 11.21 0 0 0 8.51 3.76c5.6 0 9.86-2.84 13-8.67a.6.6 0 0 1 .53-.31h.09l15.6 2.61a.6.6 0 0 1 .43.32.6.6 0 0 1 0 .54 33.64 33.64 0 0 1-12.4 14.29 32.58 32.58 0 0 1-17.4 4.83Zm16-40.16v-1.16c0-4.59-1-8.07-3.06-10.34a10.39 10.39 0 0 0-8.18-3.38 13.17 13.17 0 0 0-9.26 3.9c-2.62 2.49-4.46 6.18-5.47 11ZM309.74 139.31a.62.62 0 0 1-.47-.22.64.64 0 0 1-.12-.5l18.63-89a.6.6 0 0 1 .59-.48h17.35a.57.57 0 0 1 .47.23.6.6 0 0 1 .12.5l-18.57 89a.59.59 0 0 1-.58.48Z"
        />
      </svg>
    );
  } else {
    return (
      <img
        src="/assets/logo-siptel.png"
        alt="web"
        {...props}
      />
    );
  }
};

export default LogoSiptel;
